import React, { useMemo } from "react";

export default (props) => {
  const statusTranscod = (the_status) => {
    console.log(the_status);
    if(the_status==='attivo') return "Attivo";
    if(the_status==='rotto') return "Rotto";
    if(the_status==='sostituito') return "Sostituito";
    if(the_status==='non_posizionato') return "Non posizionato";
  }

  const status = useMemo(() => statusTranscod(props.value), [props.value]);

  return (
    <div className="colour-renderer">
      {status}
    </div>
  );
};
